module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/homepage/app-callout-2affcc1fe248bfd048c10b21933d6ee2.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/homepage/app-callout.png
// module id = 1GJH
// module chunks = 12